import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ClassOfBusinessId,
  CobMeta,
} from '@lockton-apps/shared/util/constants';
import {
  AvatarModule,
  ButtonModule,
  ExpansionModule,
} from '@lockton-apps/shared/ui/lui';
import { MatIconModule } from '@angular/material/icon';
import { CobMetaPipe } from '@lockton-apps/shared/ui/pipes';
import { LetDirective } from '@ngrx/component';

export interface ProposalProductDetailsProduct extends Omit<CobMeta, 'id'> {
  externalLink: string;
}

@Component({
    selector: 'la-proposal-product-details',
    imports: [
        CommonModule,
        AvatarModule,
        ButtonModule,
        ExpansionModule,
        MatIconModule,
        CobMetaPipe,
        LetDirective,
    ],
    templateUrl: './proposal-product-details.component.html',
    styleUrls: ['./proposal-product-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProposalProductDetailsComponent {
  @Input() cobs!: ClassOfBusinessId[];
  @Input() title!: string;
  @Input() description!: string;
}
